export default __webpack_public_path__ + "a20375b0d9e68881fdb4ecd4323978e3.webp";